(function(){
  const root = document.getElementById('coco-locator');
  if(!root) return;

  // Banner d'error visible si Google no carrega
  function showMapError(msg){
    const mapEl = document.getElementById('coco-map');
    if(mapEl){
      mapEl.innerHTML = '<div style="padding:16px;font:inherit;color:#b00020;">' + msg + '</div>';
    }
    console.error('[StoreLocator]', msg);
  }

  function waitForGoogle(cb, tries=40){
    if(window.google && google.maps){ cb(); }
    else if(tries>0){ setTimeout(()=>waitForGoogle(cb, tries-1), 150); }
    else { showMapError('No s’ha pogut carregar Google Maps. Revisa la clau/API/billing o els dominis autoritzats.'); }
  }
  waitForGoogle(init);

  function init(){
    try {
      const storesUrl = root.getAttribute('data-stores-url');
      const defaultLat = parseFloat(root.getAttribute('data-default-lat')) || 41.38879;
      const defaultLng = parseFloat(root.getAttribute('data-default-lng')) || 2.15899;
      const defaultZoom = parseInt(root.getAttribute('data-default-zoom'), 10) || 5;

      const els = {
        map: document.getElementById('coco-map'),
        list: document.getElementById('coco-list'),
        zip: document.getElementById('coco-zip'),
        zipClear: document.getElementById('coco-zip-clear'),
        typeChips: document.getElementById('coco-type-chips'),
      };

      const map = new google.maps.Map(els.map, {
        center: { lat: defaultLat, lng: defaultLng },
        zoom: defaultZoom,
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: false,
      });
      const infoWin = new google.maps.InfoWindow();

      let stores = [];
      let markers = [];
      let activeTypes = new Set();

      const slug = s => String(s||'').toLowerCase().normalize('NFD').replace(/\p{Diacritic}/gu,'');
      function debounce(fn, ms){ let t; return (...a)=>{ clearTimeout(t); t=setTimeout(()=>fn.apply(this,a), ms); } }
      function uniqueTypes(list){ const all=[]; list.forEach(s => (s.tags||[]).forEach(t=>all.push(String(t||'').trim()))); return Array.from(new Set(all.filter(Boolean))).sort((a,b)=>a.localeCompare(b)); }

      function makeChip(label){
        const b = document.createElement('button');
        b.type='button'; b.className='coco-chip'; b.textContent=label; b.setAttribute('aria-pressed','false');
        b.addEventListener('click', ()=>{ if(activeTypes.has(label)){ activeTypes.delete(label); b.classList.remove('is-active'); b.setAttribute('aria-pressed','false'); } else { activeTypes.add(label); b.classList.add('is-active'); b.setAttribute('aria-pressed','true'); } filter(); });
        return b;
      }
      function populateChips(list){ const types = uniqueTypes(list); els.typeChips.innerHTML=''; types.forEach(t => els.typeChips.appendChild(makeChip(t))); }
      function renderList(items){
        els.list.innerHTML = '';
        if(!items.length){ els.list.innerHTML = '<p class="coco-empty">No results</p>'; return; }
        const frag = document.createDocumentFragment();
        items.forEach(st => {
          const li = document.createElement('article');
          li.className = 'coco-card'; li.setAttribute('role','listitem'); li.tabIndex = 0;
          li.innerHTML = `
            <h3 class="coco-card__title">${st.name || ''}</h3>
            <p class="coco-card__addr">${st.address || ''}${st.postal_code ? ' · '+st.postal_code : ''}${st.city ? ' · '+st.city : ''}</p>
            ${st.website ? `<p><a class="coco-link" href="${st.website}" target="_blank" rel="noopener">Web</a></p>` : ''}
          `;
          li.addEventListener('click', ()=> focusStore(st.id));
          li.addEventListener('keypress', (e)=>{ if(e.key==='Enter') focusStore(st.id); });
          frag.appendChild(li);
        });
        els.list.appendChild(frag);
      }
      function renderMarkers(items){
        markers.forEach(m => m.setMap(null)); markers = [];
        const bounds = new google.maps.LatLngBounds();
        items.forEach(st => {
          const pos = { lat: st.latitude, lng: st.longitude };
          const marker = new google.maps.Marker({ position: pos, map, title: st.name || '' });
          marker.__storeId = st.id;
          marker.addListener('click', () => {
            infoWin.setContent(`
              <strong>${st.name || ''}</strong><br/>
              ${st.address || ''}${st.postal_code ? '<br/>'+st.postal_code : ''}${st.city ? ' · '+st.city : ''}<br/>
              ${st.website ? `<a href="${st.website}" target="_blank" rel="noopener">Open website</a>` : ''}
            `);
            infoWin.open({ map, anchor: marker });
          });
          markers.push(marker); bounds.extend(pos);
        });
        if(items.length){ map.fitBounds(bounds, 50); }
      }
      function focusStore(id){ const marker = markers.find(m => m.__storeId === id); if(!marker) return; map.panTo(marker.getPosition()); map.setZoom(Math.max(map.getZoom(), 12)); google.maps.event.trigger(marker, 'click'); }
      function filter(){
        const qZip = slug((els.zip.value || '').trim());
        const selTypes = Array.from(activeTypes);
        let res = stores.filter(s => {
          const hay = slug([s.city, s.postal_code].join(' '));
          const matchZip = !qZip || hay.includes(qZip);
          const matchTypes = !selTypes.length || (s.tags||[]).some(t => selTypes.includes(String(t)));
          return matchZip && matchTypes;
        });
        renderMarkers(res); renderList(res);
      }

      // events
      els.zip && els.zip.addEventListener('input', debounce(filter, 200));
      els.zipClear && els.zipClear.addEventListener('click', ()=>{ els.zip.value=''; filter(); });

      // boot
      fetch(root.getAttribute('data-stores-url'))
        .then(r=>{
          if(!r.ok) throw new Error('HTTP '+r.status);
          return r.json();
        })
        .then(json => {
          const data = Array.isArray(json) ? json : (json.stores || []);
          stores = data.filter(s => typeof s.latitude === 'number' && typeof s.longitude === 'number');
          populateChips(stores); filter();
          if(!stores.length){ map.setCenter({lat: defaultLat, lng: defaultLng}); map.setZoom(defaultZoom); }
        })
        .catch(err=>{
          showMapError('No s’ha pogut carregar la llista de botigues: ' + (err && err.message ? err.message : err));
        });

    } catch (e){
      showMapError('Error inicialitzant el mapa: ' + e.message);
    }
  }
})();
